import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { siteQueryOptions } from "@/api/siteDetails";
import { BroadcastV2EditEmailPage } from "@/features/BroadcastV2/components/BroadcastV2EditEmailPage";

const searchSchema = z.object({
  tab: z.literal("reporting").optional(),
  /** Set when a Marketing Calendar plan opened this editor; Back reopens
   * that campaign's panel (campaignId, FOG-2494), Save and Continue
   * returns to the plan wizard. */
  returnTo: z.literal("marketing-calendar").optional(),
  campaignId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/email",
)({
  component: BroadcastV2EditEmailRouteComponent,
  validateSearch: zodValidator(searchSchema),
});

function BroadcastV2EditEmailRouteComponent() {
  const { siteId } = Route.useParams();
  const { data: site } = useSuspenseQuery(siteQueryOptions(siteId));

  return (
    <BroadcastV2EditEmailPage
      siteId={siteId}
      defaultFromName={site.default_from_name}
      defaultFromEmail={site.default_from_email}
      defaultReplyTo={site.default_reply_to}
      timezone={site.timezone}
    />
  );
}
